import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'


// create an axios instance

class service {
  constructor() {
    const service = axios.create({
      baseURL: process.env.BASE_API, // url = base url + request url
      // withCredentials: true, // send cookies when cross-domain requests
      timeout: 120000 // request timeout
    })
    console.log(process.env.BASE_API, "process.env.BASE_API")
    // const options = {
    //   lock: true,
    //   text: 'Loading',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(255, 255, 255, 0)',
    //   target: '.tableloading',
    // };
    // let loadingInstance

    // request interceptor
    service.interceptors.request.use(
      config => {

        // do something before request is sent

        // if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation

        if (store.getters.token) {

          config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改


        }
        // loadingInstance = Loading.service(options)
        // console.log(options, "config")
        return config
      },
      error => {
        // do something with request error
        // for debug
        // loadingInstance.close()
        Message({
          message: data.message,
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(error)
      }

    )

    // response interceptor
    service.interceptors.response.use(
      /**
       * If you want to get http information such as headers or status
       * Please return  response => response
      */

      /**
       * Determine the request status by custom code
       * Here is just an example
       * You can also judge the status by HTTP Status Code
       */
      response => {
        // debugger;
        console.log('loadingInstance.close')

        // loadingInstance.close()

        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.statusCode === 200) {


          return Promise.resolve(response.data)
        } else {
          // if (res.message !== '查询成功') {
          //   Message({
          //     message: res.message,
          //     type: 'success',
          //     duration: 5 * 1000
          //   })
          // }

          return Promise.resolve(response.data);
        }
      },
      error => {
        // console.log(error.response, "!!") // for debug
        let data = error.response.data;
        if (data) {
          // console.log(data, "data")
          if (data.statusCode === 400) {
            if (data.message || data.msg) {
              Message({
                message: data.message,
                type: 'error',
                duration: 5 * 1000
              })
            }
          } else if (data.statusCode >= 500) {
            if (data.message || data.msg) {
              Message({
                message: data.message,
                type: 'error',
                duration: 5 * 1000
              })
            }
          } else if (data.statusCode === 401) {
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // store.dispatch('logout').then(() => {

              // })
              store.dispatch('user/resetToken').then(() => {
                location.reload()// 为了重新实例化vue-router对象 避免bug
              })
            })
          }
          else {

          }
        } else {
          if (error.response.status === 401) {
            MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // store.dispatch('logout').then(() => {

              // })
              store.dispatch('user/resetToken').then(() => {
                location.reload()// 为了重新实例化vue-router对象 避免bug
              })
            })
          }
          // loadingInstance.close()

          return Promise.reject(error)
        }
        Message({
          message: data.message,
          type: 'error',
          duration: 5 * 1000
        })
        // loadingInstance.close()
        return Promise.reject(error)

      }
    )

    return service
  }

}


//继承request写法
export class HttpService extends service {
  constructor() {
    super(...arguments);
  }
  get service() {
    return service;
  }
  post (url, params, options = {}) {
    console.log('post====params', params)
    const promise = service.post(url, params, {
      headers: options.headers,
      withCredentials: true,
    });
    return from(Promise.resolve(promise));
  }
  get (url, params, options = {}) {
    console.log('get====params', params)
    const promise = service.get(url, {
      params: params,
      headers: options.headers,
      withCredentials: true,
    });
    return from(Promise.resolve(promise));
  }

}

const httpService = new HttpService();
export const HttpServicePlugin = {
  install: function(Vue, options) {
    Object.defineProperties(Vue.prototype, {
      HttpService: {
        get() {
          return httpService;
        }
      }
    });
  }
};
export default httpService;



// WEBPACK FOOTER //
// ./src/utils/request.js